import React from 'react'
import styled from 'styled-components'
import { Container } from '@olxbr/ds-web'

const IconFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-2);
  background-color: var(--color-neutral-80);
  width: 32px;
  height: 32px;
  border-radius: 50%;
`

export const StepButtonSkeleton = () => (
  <Container flexDirection="row" alignItems="center">
    <IconFlex />
  </Container>
)
